import { get as getCookie } from 'js-cookie';
import { getSafeExperimentsContext, type InitRumConfig } from '@adv-frontend/yastore-modules/lib';
import { getRequestContext } from '../context';
import { getMonitoringExperiments } from '../experiments';

export function getRumInitConfig(): InitRumConfig {
    const requestContext = getRequestContext();

    return {
        env: requestContext.env,
        uid: getCookie('yandexuid') ?? '',
        tld: 'ru',
        reqid: requestContext.requestId,
        ...getMonitoringExperiments(getSafeExperimentsContext()),
        region: '',
        project: 'yastore-b2b',
        platform: requestContext.platform,
    };
}
